import axios from 'axios';
import config from '../../config';

export interface WebSocketTicket {
    ws_token: string;
    expires_in: number;
    expires_at: string;
}

export const createWebSocketTicket = (): Promise<WebSocketTicket> => {
    return axios.post(`${config.API_URL}/websocket/ticket`).then((response: any) => {
        return response.data?.data || response.data;
    });
};
